import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSO = '/caching'
export default {
  limparCache,
  limparChave,
  buscarCache,
}

function limparCache () {
  return Api.delete(`${RECURSO}`)
};

function limparChave (chave) {
  return Api.delete(`${RECURSO}/${chave}`)
};

function buscarCache () {
  return Api.get(`${RECURSO}`)
};
